export function getInitials(name = "") {
  return name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((w) => w[0]?.toUpperCase() ?? "")
    .join("");
}
 
/** Clamp string to maxLen chars with ellipsis */
export function truncate(str = "", maxLen = 42) {
  return str.length > maxLen ? `${str.slice(0, maxLen)}…` : str;
}